import { post } from './main';
import { BULK_REQUEST_LENDER_BROKERS } from './paths';

const BULK_REQUEST_BATCH_SIZE = 10;

/**
 * Requests lender-broker access for the given organisation IDs.
 * Splits into batches of at most 10 IDs per BulkRequestLenderBrokers call.
 */
export const bulkRequestLenderBrokers = async (
  lenderOrganisationIds: string[]
): Promise<void> => {
  if (lenderOrganisationIds.length === 0) return;

  const batches: string[][] = [];
  for (let i = 0; i < lenderOrganisationIds.length; i += BULK_REQUEST_BATCH_SIZE) {
    batches.push(lenderOrganisationIds.slice(i, i + BULK_REQUEST_BATCH_SIZE));
  }

  await Promise.all(
    batches.map((ids) =>
      post(BULK_REQUEST_LENDER_BROKERS, { lenderOrganisationIds: ids })
    )
  );
};
